(function (app) {

    app.provider("marketingTrackerSalesTrackerDashboardApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};
                        //GETS
                        service.getProductionBreakdown = function (startDate, endDate) {
                            // get Production breakdown between dates
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/ProductionBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getMarketingSourcesByDate = function (startDate, endDate) {
                            // get Marketing Scources
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/MarketingBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getOpportunitiesSummaryByDate = function (startDate, endDate) {
                            // Get Opportunity Summary
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/OpportunitiesSummary", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getOpportunitiesSourcesByDate = function (startDate, endDate) {
                            // Get Opportunity Summary
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/OpportunitiesSourceBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getOpportunitiesAppointmentsByDate = function (startDate, endDate) {
                            // Get Opportunity Advisor Appoinment Stats
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/OpportunitiesAppointmentBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getOpportunitiesAssetsByDate = function (startDate, endDate) {
                            // get Opportunity Advisor Asset Stats
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/OpportunitiesAssetBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getAdvisorProductionByDate = function (startDate, endDate) {
                            // get Advisor Production breakdown
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/AdvisorProductionBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getAdvisorPercentageBreakdown = function () {
                            // get Advisor Production breakdown 6 month, 12 month, all time
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/AdvisorPercentageBreakdown");
                        };
                        service.getAdvisorMonthlyPercentageBreakdown = function (startDate, endDate) {
                            // get Advisor Production breakdown for month for timespan
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/AdvisorMonthlyPercentageBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };
                        service.getAdvisorProductBreakdown = function (startDate, endDate) {
                             // get Advisor Sales Product breakdown
                            return marketingTrackerApiGateway.get("/SalesTracker/Dashboard/AdvisorProductBreakdown", {
                                params: {
                                    startDate: startDate,
                                    endDate: endDate
                                }
                            });
                        };

                        ////POSTS
                        service.userSignIn = function () {
                            return marketingTrackerApiGateway.post("/Users/SalesTracker/SignIn");
                        };

                        //service.createAdvisor = function (advisor) {
                        //    return marketingTrackerApiGateway.post("/SalesTracker/Settings/Advisors" + advisor);
                        //};

                        ////PUT
                        //service.updateAdvisor = function (advisor) {
                        //    return marketingTrackerApiGateway.put("/SalesTracker/Settings/Advisors/" + advisor.Id + "/Name", advisor);
                        //};
                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line